export * from './baThemeRun.directive';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/directives/baThemeRun/index.ts